import './styles.scss';

import { IAccountOption } from '../../../../providers/venue-provider';

import { RiskManagementData } from './risk-management-data';

type RiskManagementProps = {
  matrix: 'SPOT_LADDER' | 'SPOT_GRID' | 'SPOT_TIME';
  accountOption: IAccountOption;
};

const RiskManagement = ({ matrix, accountOption }: RiskManagementProps) => {
  return (
    <div className="risk-container">
      <div className="main-content">
        <div className="risk-content">
          <div className="risk-body">
            <RiskManagementData matrix={matrix} accountOption={accountOption} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RiskManagement;
